export const ThemeLandingPageQuery = (preview: boolean, slug: string) => {
  return `{
    contentData: pageTemplateThemedLandingPageCollection(
      limit: 1
      where: {urlSlug: "${slug}", website: {websiteName: "${process.env.PROJECT}"}}
         ${preview ? `preview : ${preview}` : ""}
    ) {
      items {
        pageTitle
        pageType
        sys {id}
        gaPageName
        urlSlug
        searchPanelFlag
        bannerImage {
          sys {
            id
          }
          internalName
          title
          subTitle
          backgroundColor
 
          image {
            imageTitle
            imgAltText
            imgUpload {
              url
              height
              width
            }
          }
        }
        bodyContentCollection(limit: 10) {
          items {
            sys {
              id
            }
          __typename
            internalName
            cardSectionTitle
            flagComponentStyle
            shortDescription
            longDescription
            callToAction{
             ... on CallToActionCta {
                primaryCtaUrl
                primaryCtaLabel
                primaryCtaTarget
                primaryCtaEventName
              }
            }
            mediaCardsCollection {
              items {
                __typename
               
              ... on MetaTagArticleType{
                title
              }
              ... on MetaTagTheme {
                title
              }
                ... on MetaTagSubTopic {
                title
              }
 
              ... on MetaTagCity {
                title
              }
 
              ... on MetaTagTopic {
                title
              }
 
              ... on MetaTagRegion {
                title
              }
              ...on MetaTagNation {
                title
              }

            }
          }
          }
        }
      }
    }
  }`;
};

export const ThemeLandingSeoQuery = (slug: string) => {
  return `{contentData:pageTemplateThemedLandingPageCollection(
    limit: 1
     where: {urlSlug: "${slug}", website: {websiteName: "${process.env.PROJECT}"}}
  ) {
    items {
      seoFields {
        metaTite
        metaDescription
         metaKeywords
         robots
        canonical
      }
        robots {
        title
      }
    }
  }
}`;
};

export const ArticleQuery = (preview: boolean, slug: string) => {
  return `{
    contentData: pageTemplateThemedLandingPageCollection(
      limit: 1
      where: {urlSlug: "${slug}", website: {websiteName: "${process.env.PROJECT}"}}
        ${preview ? `preview : ${preview}` : ""}
    ) {
      items {
        bodyContentCollection(limit: 20
        where: {internalName_not: "Article landing page - Level 1 heading - Whatuni"}
        ) {
          items {
            sys {
              id
            }
            internalName
            cardSectionTitle
            flagComponentStyle
            mediaCardsCollection {
              items {
                ... on DynamicMediaComponent {
                  title
                  longDescription {
                    json
                  }
                }
                ... on MetaTagTopic {
                  title
                  id
                }
                ... on MetaTagSubTopic {
                  title
                  subTopic
                  parent {
                    title
                  }
                }
              }
            }
          }
        }
      }
    }
  }`;
};

export const ArtcileSliderQuery = (
  preview: boolean,
  articleArray: string,
  condition: "AND" | "OR" = "OR",
  excludeSlug?: string,
) => {
  const excludeFilter = excludeSlug ? `, urlSlug_not: "${excludeSlug}"` : "";
  return `{
  contentData: articleCollection(
    limit: 10
    where: {${condition}: ${articleArray}, website: {websiteName: "${process.env.PROJECT}"}${excludeFilter}}
      order: modifiedDate_DESC
       ${preview ? `preview : ${preview}` : ""}
  ) {
    items {
    sys{id}
      pageTitle
      urlSlug
      metaTagTopicsCollection {
        items {
          title
        }
      }
      metaTagSubTopicsCollection {
        items {
          ... on MetaTagSubTopic {
            title
          }
        }
      }
      bannerImageCollection {
        items {
        sys{
        id
        }
          imgAltText
          imgUpload {
            url
          }
        }
      }
      shortDescription
      modifiedDate
    }
  }
}`;
};

export const ArtcileGridQuery = (
  preview: boolean,
  articleArray: string,
  skipcount: any,
  pageSize: number = 9,
  order: string = "modifiedDate_DESC",
) => {
  return `{
  contentData: articleCollection(
    limit: ${pageSize}
    skip: ${skipcount}
    where: {OR: ${articleArray}, website: {websiteName: "${process.env.PROJECT}"}}
      order: ${order}
       ${preview ? `preview : ${preview}` : ""}
  ) {
    total
    items {
    sys{id}
      pageTitle
      urlSlug
      metaTagTopicsCollection {
        items {
          title
        }
      }
      metaTagSubTopicsCollection {
        items {
          ... on MetaTagSubTopic {
            title
          }
        }
      }
      bannerImageCollection {
        items {
        sys{
        id
        }
          imgAltText
          imgUpload {
            url
          }
        }
      }
      shortDescription
      modifiedDate
    }
  }
}`;
};

const themeLandingFaqQuery = (internalName: string, urlSlug: string) => {
  return `{
 
  pageTemplateThemedLandingPageCollection(
 
    limit: 1
 
    where: {urlSlug: "${urlSlug}", website: {websiteName: "${process.env.PROJECT}"}}
 
  ) {
 
    items {
 
      bodyContentCollection(
 
        where: {internalName:"${internalName}"}
 
        limit: 1
 
      ) {
 
        items
 
{
 
  ... on MultipleCardContainer {
 
    internalName
 
    cardSectionTitle
 
    shortDescription
 
    flagComponentStyle
 
    mediaCardsCollection {
 
      items {
 
        ... on PageComponentFaq {
 
          faqComponentName
 
          faqComponentTitle
 
          faqEntriesCollection {
 
            items {
 
              question
 
              answer
 
            }
 
          }
 
        }
 
      }
 
    }
 
  }
 
}
 
      }
 
    }
 
  }
 
}
 `;
};

const subjectGuideAjax = () => {
  return `{
  articleCollection(where: {articleType: {title: "Subject guide"}}, order: pageTitle_ASC, limit: 100) {
    total
    items {
      pageTitle
      urlSlug
    }
  }
}`;
};

export { themeLandingFaqQuery, subjectGuideAjax };
